/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import MediaQuery from 'react-responsive';

import Button from '../../Button';
import Icon from '../../Icon';
import { ACTIONS } from '../../../constants/strings';
import { BREAKPOINT } from '../../../constants/styles';

const ExportBtn = ({ onClick }) => (
  <MediaQuery maxWidth={BREAKPOINT}>
    {isMobile => {
      const additionalClass = isMobile ? 'ph2' : 'ph3';
      const btnClassName = classNames('pv1', additionalClass);
      const color = isMobile ? 'accent' : 'primary';
      const iconClassName = classNames({ 'mr2 v-btm': !isMobile });
      const name = isMobile ? 'pdf-mobile' : 'pdf';
      const width = isMobile ? 24 : 18;
      const height = isMobile ? 24 : 20;

      return (
        <Button {...{ color, onClick }} className={btnClassName} raised>
          <Icon {...{ height, width, name }} className={iconClassName} />
          {!isMobile && <FormattedMessage {...ACTIONS.survey.exportToPDF} />}
        </Button>
      );
    }}
  </MediaQuery>
);

ExportBtn.propTypes = {
  onClick: PropTypes.func,
};

export default ExportBtn;



// WEBPACK FOOTER //
// ./src/components/common/ProgramPopup/ExportBtn.jsx